// TikTok Branded Content Notice - displays campaign invite link and instructions

import { ExternalLink, Info } from "lucide-react";

interface TikTokBrandedContentNoticeProps {
  inviteLink: string;
}

export function TikTokBrandedContentNotice({
  inviteLink,
}: TikTokBrandedContentNoticeProps) {
  return (
    <div className="flex gap-3 p-3 rounded-lg bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-800">
      <Info className="h-4 w-4 mt-0.5 shrink-0 text-blue-600 dark:text-blue-400" />
      <div className="text-sm text-blue-800 dark:text-blue-200">
        <strong className="block mb-1">Link To TikTok Campaign</strong>
        <p className="mb-2">
          Content must be linked to a TikTok Creator Marketplace Campaign.
        </p>
        <p className="mb-2">
          If you are using a phone and have not posted your TikTok post already,
          you can upload your content using the{" "}
          <a
            href={inviteLink}
            target="_blank"
            rel="noopener noreferrer"
            className="underline font-medium inline-flex items-center gap-1"
          >
            invite link
            <ExternalLink className="h-3 w-3" />
          </a>{" "}
          to upload a new or existing post to the TikTok Campaign.
        </p>
        <a
          href="https://intercom.help/aspireiq_elevate/en/articles/8281029-creating-branded-content-on-tiktok"
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-xs inline-flex items-center gap-1"
        >
          Learn more
          <ExternalLink className="h-3 w-3" />
        </a>
      </div>
    </div>
  );
}
